module.exports = __webpack_public_path__ + "img/8.12e13552.png";